import throttle from 'lodash.throttle';

import { LOAD_INITIAL_LOCAL_STORAGE } from 'constants/reduxActions';

import { loadFromLocalStorage, saveToLocalStorage } from 'helpers/localStorageUtilities';

export default function connectStoreToLocalStorage(store) {
  // hook local storage up to the store
  const localState = loadFromLocalStorage('state');
  const initialLocalStorage = localState?.localStorage || {};

  store.dispatch({ type : LOAD_INITIAL_LOCAL_STORAGE, initialLocalStorage });

  // automatically save section of store to local storage
  store.subscribe(throttle(() => {
    const { localStorage } = store.getState();
    saveToLocalStorage('state', { localStorage });
  }, 1000));

  return initialLocalStorage;
}
